import Component from 'component';
import { jumpToTarget } from '../helpers/jumpToTarget';
class JumpLink extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.jumpTarget = this.$el.attr('href');
  }
  addListeners() {
    this.$el.on('click', ::this.onClickLink);
  }
  onClickLink(e) {
    e.stopPropagation();
    e.preventDefault();
    jumpToTarget(this.jumpTarget);
  }
}

export default JumpLink;



// WEBPACK FOOTER //
// ./src/tc/js/components/JumpLink.js